import {
  CheckExtraChangeImpactResponse,
  ExtraChangeImpact as ExtraChangeImpactProto,
  ExtraImpactBlock as ExtraImpactBlockProto,
} from "../../../../gen/witbooking/backoffice/extra/v1/extra_api_pb";
import {
  ExtraChangeImpact,
  ExtraChangeImpactResult,
  ExtraImpactBlock,
} from "../../domain/entities/ExtraChangeImpact";
import { ExtraCategoryMapper } from "./ExtraCategoryMapper";
import { ValidationIssueMapper } from "./ValidationIssueMapper";

export class ExtraChangeImpactMapper {
  static toDomain(proto: CheckExtraChangeImpactResponse): ExtraChangeImpactResult {
    return ExtraChangeImpactResult.of(
      proto.getBlocked(),
      proto
        .getImpactsList()
        // An impact without its issue cannot be shown or classified.
        .filter(impact => impact.hasIssue())
        .map(ExtraChangeImpactMapper.impactToDomain)
    );
  }

  private static impactToDomain(proto: ExtraChangeImpactProto): ExtraChangeImpact {
    return ExtraChangeImpact.of(
      ValidationIssueMapper.toDomain(proto.getIssue()!),
      proto.getBlocksList().map(ExtraChangeImpactMapper.blockToDomain)
    );
  }

  private static blockToDomain(proto: ExtraImpactBlockProto): ExtraImpactBlock {
    return ExtraImpactBlock.of({
      propertyTicker: proto.getPropertyTicker(),
      propertyName: proto.getPropertyName(),
      accommodationId: proto.getAccommodationId(),
      accommodationTicker: proto.getAccommodationTicker(),
      accommodationName: proto.getAccommodationName(),
      category: ExtraCategoryMapper.toDomain(proto.getCategory()),
      blockEnabled: proto.getBlockEnabled(),
    });
  }
}
